<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Borrower Experience">
        <base-button icon-right="plus" secondary :to="{ name: 'experience.create' }">
          Add Experience
        </base-button>
      </hero-header>
    </template>
    <experience-filter />
  </base-content>
</template>

<script>
import ExperienceFilter from '@/components/ExperienceFilter.vue'
import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    ExperienceFilter,
    HeroHeader
  }
}
</script>
